import React from 'react';
import {ConfigurationModel} from 'franke-trough-dependencies';
import { FormattedMessage } from 'react-intl';

import MESSAGES from './ListItemDetail.messages';

export const CompletionStatus: React.FunctionComponent<{type: ConfigurationModel['completionStatus']}> = (props) => {
  switch (props.type) {
    case 'request':
      return <FormattedMessage {...MESSAGES.listItemDetailRequest} />;
    case 'offer':
      return <FormattedMessage {...MESSAGES.listItemDetailOffer} />;
    case 'order':
      return <FormattedMessage {...MESSAGES.listItemDetailOrder} />;
    case 'failed':
      return <FormattedMessage {...MESSAGES.listItemDetailFailed} />;
    case 'queued':
      return <FormattedMessage {...MESSAGES.listItemDetailQueued} />;
    default:
      return <FormattedMessage {...MESSAGES.listItemDetailDraft} />;
  }
}